import {
    createDBInputValidation,
    createDBEntityValidator,
} from 'shared/db/validation/common';
import { Logger } from 'shared/db/validation/databaseInput';
import { createUsersSchemas } from 'shared/db/validation/schema/users';
import { Validator } from 'shared/db/validation/validator';
import { DeleteRawRecord } from 'shared/types/rawRecordFields';
import { UserRawRecord, UserUpdateRawRecord } from 'shared/types/User';
import { UserEntityDBValidation } from 'shared/types/validation';

import { createLoggerFor } from '@/services/logger';
import { getValidationStrategy } from '@/utils/validations';

const schemas = createUsersSchemas();

const addValidator = createDBEntityValidator<UserRawRecord>(schemas.add);
const updateValidator = createDBEntityValidator<UserUpdateRawRecord>(
    schemas.update,
);
const deleteValidator = createDBEntityValidator<DeleteRawRecord>(
    schemas.delete,
);

const softValidation = {
    logger: createLoggerFor('db-validation-users'),
    hardErrorFields: [],
};

const validationStrategy = getValidationStrategy(softValidation);

export const createUsersInputValidation = <T extends Record<string, unknown>>(
    validator: Validator<T>,
    softValidation?: {
        logger: Logger;
        hardErrorFields: string[];
    },
) => createDBInputValidation<T>(validator, softValidation);

export const usersInputValidation: UserEntityDBValidation = {
    add: createUsersInputValidation(addValidator, validationStrategy),
    update: createUsersInputValidation(updateValidator, validationStrategy),
    delete: createUsersInputValidation(deleteValidator, validationStrategy),
};
